/**
 * @file コンポーネント：フル動画ページシェーマポップアップ ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const PopupSchema = (props) => {
    // 別コメントのシェーマが選択された際にkeyを変更してコンポーネントをリセット
    const contentKey = props.popupSchemaSlider
        ? "content-" + props.popupSchemaSlider[0].id
        : "content";

    // Presenterに渡す
    return <Presenter {...props} contentKey={contentKey} />;
};
